import { decamelizeKeys, filterQueryParams } from '@/utils'
import queryString from 'query-string'
import { ScheduleCommentAPI } from './types'

export const scheduleCommentApi: ScheduleCommentAPI = ky => {
  return {
    async fetch({ patientId, scheduleId }) {
      const searchParams = filterQueryParams({ scheduleId })

      return await ky(`schedule/comments/${patientId}/`, {
        method: 'get',
        searchParams: queryString.stringify(decamelizeKeys(searchParams))
      }).json()
    },

    async fetchPage({ url }) {
      return await ky(url, {
        method: 'get'
      }).json()
    },

    async create({ params }) {
      return await ky(`schedule/comment/`, {
        method: 'post',
        json: params
      }).json()
    },

    async delete({ commentId }) {
      await ky(`schedule/comment/${commentId}/`, {
        method: 'delete'
      })
    }
  }
}
